import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';

// noinspection SpellCheckingInspection
const app = firebase.initializeApp({
    apiKey: "AIzaSyC8lvoJa01XggaR0RGVWUazNFBo0raEXBs",
    authDomain: "mrbbot-cms.firebaseapp.com",
    databaseURL: "https://mrbbot-cms.firebaseio.com",
    projectId: "mrbbot-cms",
    storageBucket: "content.imaphotographer.com",
    messagingSenderId: "362862799425"
});

export const contentUrlPrefix = "https://content.imaphotographer.com/";

export function triggerSiteBuild(buildMessage) {
    console.log(`Building site... (${buildMessage})`)
    return fetch(
        "https://api.cloudflare.com/client/v4/pages/webhooks/deploy_hooks/9e988acf-4cd9-4061-a00a-b8acf3f01da9",
        {
            method: "POST",
            mode: "no-cors",
        }
    );
}

export const db = app.database();
export const auth = app.auth();
export const storage = app.storage();

export const signIn = window.signIn = (email, password) => auth.signInWithEmailAndPassword(email, password);
export const signOut = window.signOut = () => auth.signOut();